import React from 'react'
import Hero from '../Components/Hero'
import Item from '../Components/Item'

const Home = () => {
    return (
        <>
          <Hero/>  
          <Item/>
        </>
    )
}

export default Home
